import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export interface ITemplatePreviewDialogData {
  title?: string;
  subject?: string;
  content: string;
  isHtml?: boolean;
}

@Component({
  selector: 'app-template-preview-dialog',
  templateUrl: './template-preview-dialog.component.html',
  styleUrls: ['./template-preview-dialog.component.scss']
})
export class TemplatePreviewDialogComponent {
  safeContent: SafeHtml;

  constructor(
    public dialogRef: MatDialogRef<TemplatePreviewDialogComponent>,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: ITemplatePreviewDialogData
  ) {
    this.safeContent = this.data.isHtml
      ? this.sanitizer.bypassSecurityTrustHtml(this.data.content || '')
      : this.sanitizer.bypassSecurityTrustHtml(this.escapeText(this.data.content || ''));
  }

  // plain-text templates (SMS/WhatsApp) must not be interpreted as HTML
  private escapeText(text: string): string {
    const div = document.createElement('div');
    div.innerText = text;
    return div.innerHTML.replace(/\n/g, '<br>');
  }

  close(): void {
    this.dialogRef.close();
  }
}
